<template>
    <!-- v-show="displayOtherPaymentAccount" -->
    <div class="pay_cont bankTransfer target_directdebit"> 
        <div class="row card-method">
            <div class="tab-cont-st2">
                <div class="form_group_a">
                    <div class="payment-item-a">
                        <div class="payment-title">
                            <p class="payment-item-title">자동이체 비밀번호</p>
                        </div>
                        <div class="payment-content">
                            <div class="form-item-a">
                                <input
                                    autocomplete="off"
                                    type="password"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    maxlength="6"
                                    class="form_input"
                                    placeholder="자동이체 비밀번호 6자리"
                                    v-model="depositPassword"
                                    @change="onChangeDepositPassword"
                                >
                            </div>
                        </div>
                    </div>
                    <p class="a-pay-backTransfer-txt">* 자동이체는 계좌 등록 후 사용이 가능합니다.</p>
                </div>
                <div class="payment-item-a-info">
                    <a class="title st2" @click="toggleAccordion" :class="classCollapsed">자동이체 안내
                    <span class="hidden">닫기</span>
                    </a>
                </div>
                <div
                    class="panel-collapse detailCont collapse"
                    :class="classAccountInfoIn"
                    :aria-expanded="(!accordionCollapsed).toString()"
                >
                    <div class="panel-body0">
                        <ul class="list-type5">
                            <li>자동이체는 마이페이지에서 계좌 등록 후 사용이 가능합니다.</li>
                            <li>자동이체 결제 후 주문 취소하실 경우 환불시점은 영업일 기준 익일 오후 5시입니다.</li>
                            <li><em>자동이체 가능 은행</em> : 국민, 신한, 우리, SC제일, KEB하나, 농협, 기업, 씨티, 우체국, 유안타증권</li>
                        </ul>

                        <ul class="list-type5">
                            <li><strong>거래가능시간</strong>
                            <ul>
                                <li>- 한도금액을 초과하는 주문 시에는 주문을 나누어 주십시오.</li>
                                <li>- 자동이체는 은행에 따라 새벽시간(00시 ~ 00시 30분)에 거래가 불안정할 수 있습니다.</li>
                                <li>-
                                <span>
                                    또한, 월말에는 거래가능시간이라도 은행에 따라 은행영업시간(오후 4시) 이후에 거래가 되지 않을 수 있으니
                                    자동이체 이외의 타 결제수단을 이용하시기 바랍니다.
                                </span>
                                </li>
                            </ul>
                            </li>
                            <li>SC제일은행, 농협, 우리은행, KEB하나은행, 신한은행, 기업은행, 씨티은행, 우체국 : 한도 없음</li>
                            <li>유안타증권 : 1일 1,000만원 한도</li>
                            <li>KEB하나은행 : 1거래당 1,000만원 한도</li>
                            <li>국민은행 : 1거래당 600만원 한도</li>
                        </ul>
                        <ul class="list-type5">
                            <li>자동이체계좌는 공동사업자1(공동사업자1 & 공동사업자2 인 경우 공동사업자1)의 주민등록번호로 개설된 계좌만 가능합니다.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <modal-alert ref="refAlert" />
    </div>
</template>
<script>

import ModalAlert from "@/components/global/ModalAlert";
import orderApi from '@/apis/order';

export default {
  name: "DirectDebit",
  components: {
    ModalAlert,
  },
  methods: {
    toggleAccordion() {
      this.accordionCollapsed = !this.accordionCollapsed;
    },
    async onChangeDepositPassword() {
      this.$store.commit('account/updatePassword', {
        secret: "",
        validated: false,
      });
      if (this.depositPassword.length === 6) {
        const passwordCheckResponse = await orderApi.checkAutoWithdrawPassword(this.depositPassword);
        if (passwordCheckResponse.error) {
          this.$refs.refAlert.openWithMessage(passwordCheckResponse.error.returnMessage);
        } else {
          this.$store.commit("account/updatePassword", {
            secret: this.depositPassword,
            validated: true,
          });
        }
      }
    },
  },
  computed: {
    classCollapsed() {
      return this.accordionCollapsed ? "collapsed" : "";
    },
    classAccountInfoIn() {
      return !this.accordionCollapsed ? "in" : "";
    }
  },
  props: {

  },
  data() {
    return {
      accordionCollapsed: true,
      depositPassword: "",
    }
  },
}
</script>
<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/composition/payment/DirectDebit.vue